import LinkedText from "../linkedText/linkedText.component";

export interface InfoCard {
  title: string;
  // `**bold**` and `[label](/route)` supported.
  text: string;
}

interface InfoCardGridProps {
  cards: InfoCard[];
}

// Grid of plain title + text cards (the preview's `.pg-3 .pc`): one column
// on phones, two from `sm`, three from `lg`.
const InfoCardGrid = ({ cards }: InfoCardGridProps) => (
  <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
    {cards.map((card) => (
      <article
        key={card.title}
        className="grid content-start gap-1.5 rounded-[22px] bg-white px-[22px] py-5 shadow-card"
      >
        <h3 className="text-[1.12rem] leading-tight font-bold">{card.title}</h3>
        <p className="text-[15.5px] leading-normal text-ink-muted">
          <LinkedText text={card.text} />
        </p>
      </article>
    ))}
  </div>
);

export default InfoCardGrid;
